/**
* map JS
* -----------------------------------------------------------------------------
*
* All the JS for the map component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// VARS that are set in map.php:
// mapLocations - array of objects [{address, city, state, zip, coordinates: {lat, lng}}]
// mapPin - url string of pin image
// mapStyle - url string of mapbox studio style link
// mapKey - string of mapbox api key
( function( app ) {
  const COMPONENT = {

    className: 'map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // mapKey variable is set in the PHP file
      mapboxgl.accessToken = ll_mapbox.token;
      // Initialize the map
      const mapLocations = $( '.map' ).data( 'locations' );
      const mapId = $( '.map' ).attr( 'id' );
      let distance = 50;
      let map;

      function loadLocations( locations ) {
        if ( locations.length > 0 ) {
          map = new mapboxgl.Map( {
            container: 'map', // mounts on element with id of "map"
            style: ll_mapbox.style, // stylesheet URL set in PHP file
            // this map is centered on the US, but you should change it your location
            center: [locations[0].coordinates.long, locations[0].coordinates.lat],
            zoom: 10,
          } );

          // Wait for the map to load
          map.on( 'load', () => {
            // load the pin image (has to be png or jpg, [SVG DOESN'T WORK])
            // mapPin is set in PHP file
            map.loadImage( ll_mapbox.pin, ( err, img ) => {
              if ( err ) throw err;
              // Will rerference "pin" later
              map.addImage( 'll_pin', img );
              const features = [];
              let i = 0;
              // for multi-location map, iterate over locations and add them to the array of features
              locations.forEach( ( loc, index ) => {
                const feature = {
                  type: 'Feature',
                  properties: {
                    description:
                    `<span class="px-4 pt-4 block font-bold text-sm text-center">${loc.title}</span>
                    <p class="text-center mt-1"><a href="tel:+1${loc.formattedPhone}" class="text-sm hover:underline">${loc.phone}</a></p>
                    <address class="pt-1 pb-4 px-4 not-italic text-sm text-center">
                      <span class="block">${loc.address.street}</span>
                      <span class="block">${loc.address.city}, ${loc.address.state} ${loc.address.zip}</span>
                    </address>`,
                  },
                  geometry: {
                    type: 'Point',
                    coordinates: [parseFloat( loc.coordinates.long ), parseFloat( loc.coordinates.lat )],
                  },
                };

                const el = document.createElement( 'div' );
                el.className = 'marker';
                el.id = 'marker-' + ( i + 1 );
                el.innerHTML = '<span><b>' + ( i + 1 ) + '</b></span>';

                // make a marker for each feature and add it to the map
                new mapboxgl.Marker( el )
                    .setLngLat( feature.geometry.coordinates )
                    .addTo( map );

                features.push( feature );

                if ( index === 0 ) {
                  new mapboxgl.Popup( {offset: {'bottom': [0, -49]}} )
                      .setLngLat( feature.geometry.coordinates )
                      .setHTML( feature.properties.description )
                      .addTo( map );
                }
                i++;
              } );

              // add this "geojson" object to the map, passing in the features array
              map.addSource( 'points', {
                type: 'geojson',
                data: {
                  type: 'FeatureCollection',
                  features,
                },
              } );
              // create a symbol layer using the "point" source that we just added
              map.addLayer( {
                id: 'points',
                type: 'symbol',
                source: 'points',
                layout: {
                  'icon-image': 'll_pin', // uses the "pin" image we added above
                  'icon-size': 1, // relative to the original image size (unfortunately)
                  'icon-anchor': 'bottom', // will put the bottom center of the pin on the location
                },
              } );

              // this handles the popups when the pin is clicked
              map.on( 'click', 'points', function( e ) {
                const coordinates = e.features[0].geometry.coordinates.slice();
                const description = e.features[0].properties.description;

                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while ( Math.abs( e.lngLat.lng - coordinates[0] ) > 180 ) {
                  coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                map.flyTo( {
                  center: [
                    e.lngLat.lng,
                    e.lngLat.lat,
                  ],
                  essential: true,
                } );

                new mapboxgl.Popup( {offset: {'bottom': [0, -49]}} )
                    .setLngLat( coordinates )
                    .setHTML( description )
                    .addTo( map );
              } );

              // make the cursor a pointer when over the pin
              map.on( 'mouseenter', 'points', function() {
                map.getCanvas().style.cursor = 'pointer';
              } );
              map.on( 'mouseleave', 'points', function() {
                map.getCanvas().style.cursor = '';
              } );

              // Disable drag and zoom handlers.
              map.dragging.disable();
              map.touchZoom.disable();
              map.doubleClickZoom.disable();
              map.scrollWheelZoom.disable();
              map.keyboard.disable();

              // Disable tap handler, if present.
              if ( map.tap ) map.tap.disable();
            } );
          } );
        } else {
          $( '.find-a-distributor .locations-list' ).html( '<p>No results found within ' + distance + ' miles of this location.</p>' );
        }
      }

      // loadLocations( mapLocations );
      initMap( 64030, 50 );

      $( '#distributor-search' ).submit( function( e ) {
        e.preventDefault();
        $( '#distributor-search' ).find( 'button' ).attr( 'disabled', true );
        $( '.map, .find-a-distributor' ).addClass( 'is-loading' );

        if ( $( this ).find( 'input[name="search_radius"]' ).val() ) {
          distance = $( this ).find( 'input[name="search_radius"]' ).val();
        } else {
          distance = 10;
        }

        const value = $( this ).find( 'input[name="search_location"]' ).val();
        initMap( value, distance );
      } );

      function initMap( searchVal, searchDistance ) {
        $.get( 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + searchVal + '.json?access_token=' + mapboxgl.accessToken, function( data ) {
          $.post(
              site_info.ajax_url,
              {
                action: 'll_run_function',
                function: 'location_search',
                params: {
                  lat: data.features[0].center[1],
                  lng: data.features[0].center[0],
                  distance: searchDistance,
                },
              },
              function( data, textStatus, xhr ) {
                data = $.parseJSON( data );
                if ( data.status === 'success' ) {
                  // test
                  let locationsCards = '';
                  $( data.response.location_result ).each( function( key, val ) {
                    locationsCards += val.template;
                  } );
                  $( '.find-a-distributor .locations-list' ).html( locationsCards );

                  const newLocations = [];
                  $( '.find-a-distributor .location' ).each( function( key, val ) {
                    const thisLocation = {};
                    thisLocation.address = {};
                    thisLocation.coordinates = {};
                    thisLocation.address.street = $( val ).find( '.address .street' ).text();
                    thisLocation.address.city = $( val ).find( '.address .city' ).text();
                    thisLocation.address.state = $( val ).find( '.address .state' ).text();
                    thisLocation.address.zip = $( val ).find( '.address .zip' ).text();
                    thisLocation.phone = $( val ).find( '.phone' ).text();
                    thisLocation.formattedPhone = $( val ).find( '.phone' ).text().replace( /[.\D+]/gm, '' );
                    thisLocation.title = $( val ).find( '.title' ).text();
                    thisLocation.coordinates.lat = $( val ).attr( 'data-lat' );
                    thisLocation.coordinates.long = $( val ).attr( 'data-long' );

                    newLocations.push( thisLocation );
                  } );
                  $( '#distributor-search' ).find( 'button' ).removeAttr( 'disabled' );
                  $( '.map, .find-a-distributor' ).removeClass( 'is-loading' );
                  loadLocations( newLocations );
                }
              }
          );
        } );
      }

      $( document ).on( 'click', '.find-a-distributor .locations-list .location', function( e ) {
        $( '.find-a-distributor .location' ).removeClass( 'is-hovered' );
        $( this ).addClass( 'is-hovered' );
        const lat = $( this ).attr( 'data-lat' );
        const long = $( this ).attr( 'data-long' );
        const coordinates = {
          lng: long,
          lat: lat,
        };
        const description = $( this ).find( '.popup-info' ).html();

        const popup = document.getElementsByClassName( 'mapboxgl-popup' );
        if ( popup.length ) {
          popup[0].remove();
        }

        map.flyTo( {
          center: [
            long,
            lat,
          ],
          essential: true,
        } );

        new mapboxgl.Popup( {offset: {'bottom': [0, -49]}} )
            .setLngLat( coordinates )
            .setHTML( description )
            .addTo( map );
      } );

      $( document ).on( 'click', '.map .marker', function() {
        const id = $( this ).attr( 'id' );
        $( '.find-a-distributor .location' ).removeClass( 'is-hovered' );
        $( '.find-a-distributor .location#location-' + id ).addClass( 'is-hovered' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'map', COMPONENT );
} )( app );
